import React from 'react';
import TuneIcon from '@mui/icons-material/Tune';
import { makeStyles } from '@mui/styles';
import PropTypes from 'prop-types';
import * as TeamAlertsConstants from '../../utils/constants';
import TooltipFilter from './TooltipFilter';
import CustomSortIconButton from '../CustomSort/CustomSortIconButton';

const useStyles = makeStyles(() => ({
    columnFilterTitle: {
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        verticalAlign: 'middle'
    },
    columnRoot: {
        display: 'inline-flex',
        float: 'left'
    }
}));

const ColumnFilter = ({ filterType, columnTitle, filterOptionsContext }) => {
    const classes = useStyles();

    return <div className={classes.columnRoot}>
        <TooltipFilter filterType={TeamAlertsConstants.gridFilterTypes[filterType]}>
            {filterOptionsContext[filterType].isOptionActive ?
            <span className={classes.columnFilterTitle}>{columnTitle}&nbsp;&nbsp;<TuneIcon /></span> :
            <span>{columnTitle}</span>}
            </TooltipFilter>
        <CustomSortIconButton filterType={TeamAlertsConstants.gridFilterTypes[filterType]} />
    </div>;
}

ColumnFilter.propTypes = {
    filterType: PropTypes.string.isRequired,
    columnTitle: PropTypes.string.isRequired,
    filterOptionsContext: PropTypes.object,
}

export default ColumnFilter;
